export function deviceType(deviceType: string): string {
  return deviceType
    .replaceAll('_', ' ') // Replace underscores with spaces
    .split(' ') // Split into words
    .map((word) =>
      word.length <= 4 || /\d/.test(word)
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(' '); // Reconstruct the string
}
